export const featuresList = [
  'leather-interior',
  'sun-roof',
  'heated-seats',
  'cooled-seats',
  'third-row-seat',
  'rear-view-camera',
  'blind-spot-sensors',
  'lane-departure-warning',
  'park-assist',
  'gps-navigation',
  'premium-sound',
  'usb',
  'aux-connect',
  'bluetooth-music',
  'satellite-radio',
  'hands-free',
  'remote-start',
  'keyless-ignition',
  'power-driver-seat',
  'power-passenger-seat',
  'tow-hitch',
  'auto-windshield-wipers',
  'heads-up-display',
  'xenon-led-lights',
  'dvd-video',
  'home-link',
];